export default {"src":"/_next/static/media/mysql.9b7d75c7.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};